/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type CreateAdvancedPatientFileMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  input: Types.CreatePatientFileInput
}>

export type CreateAdvancedPatientFileMutation = {
  __typename?: 'Mutation'
  createPatientFile: {
    __typename?: 'CreatePatientFile'
    uploadURL: string
    method: string
    file: { __typename?: 'PatientFile'; fileID: string; filename: string; contentType: string; size: number }
  }
}

export const CreateAdvancedPatientFileDocument = gql`
  mutation createAdvancedPatientFile($uid: ID!, $input: CreatePatientFileInput!) {
    createPatientFile(uid: $uid, input: $input) {
      uploadURL
      method
      file {
        fileID
        filename
        contentType
        size
      }
    }
  }
`
export type CreateAdvancedPatientFileMutationFn = Apollo.MutationFunction<
  CreateAdvancedPatientFileMutation,
  CreateAdvancedPatientFileMutationVariables
>

/**
 * __useCreateAdvancedPatientFileMutation__
 *
 * To run a mutation, you first call `useCreateAdvancedPatientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvancedPatientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvancedPatientFileMutation, { data, loading, error }] = useCreateAdvancedPatientFileMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdvancedPatientFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdvancedPatientFileMutation,
    CreateAdvancedPatientFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAdvancedPatientFileMutation, CreateAdvancedPatientFileMutationVariables>(
    CreateAdvancedPatientFileDocument,
    options
  )
}
export type CreateAdvancedPatientFileMutationHookResult = ReturnType<typeof useCreateAdvancedPatientFileMutation>
export type CreateAdvancedPatientFileMutationResult = Apollo.MutationResult<CreateAdvancedPatientFileMutation>
export type CreateAdvancedPatientFileMutationOptions = Apollo.BaseMutationOptions<
  CreateAdvancedPatientFileMutation,
  CreateAdvancedPatientFileMutationVariables
>
